var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"buy-ratio"},[_c('buy-ratio-item',{attrs:{"toYear":_vm.toYear,"type":"sale","statisticsData":_vm.statisticsData}}),_c('buy-ratio-item',{attrs:{"toYear":_vm.toYear,"type":"deal","statisticsData":_vm.statisticsData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }